import Actions from './account-template-actions';
import Api from './account-template-api';
import Collection from './account-template-collection';
import Model from './account-template-model';
import reducer from './account-template-reducer';
import sagas from './account-template-sagas';
import Selectors from './account-template-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'accountTemplate',
  reducer,
  sagas:     [sagas],
  Selectors,
};
